// The manual flow accepts up to 100 VINs, shown 25 per page across at most
// 4 pages on the Review step.
export const ITEMS_PER_PAGE = 25;
